/* ---------------------------------------------------------------------
Global Js
Target Browsers: All
------------------------------------------------------------------------ */

var FX = (function(FX, $) {

    $(window).load(function() {

    });

    /**
     * Accordion
     */

    FX.Accordion = {

        init: function() {
            this.bind();
            $('.accordion-content').hide();
        },

        bind: function() {
            $('.accordion-toggle > .accordion-title').on( 'toggle-panel', this.togglePanel );
            $('.accordion-toggle > .accordion-title').click( this.togglePanel );
        },

        togglePanel: function() {
            $this = $(this);
            $target =  $this.parent().next();

            // console.log($this);

            if ( $this.hasClass('active') ) {
                $this.removeClass('active');
                $target.slideUp(300, function () {
                    $target.removeClass('active')
                    $target.removeClass('block');
                });
            } else {
                $('.accordion-content').removeClass('active');
                $('.accordion-content').slideUp();
                $('.accordion-title').removeClass('active');
                $this.addClass('active');
                $target.addClass('active');
                $target.addClass('block');
                $target.slideDown('slow', function () {});
                
            }
        }
    };

    /**
     * Doc Ready
     */
    $(function() {
        /* icheck */
        $('input[type="checkbox"], input[type="radio"]').not('.plain-checkbox').each(function(){
            var $this = $(this),
              label = $this.next(),
              label_text = label.text();

            label.remove();
            $this.iCheck({
              checkboxClass: 'icheckbox_line-purple',
              radioClass: 'iradio_line-purple',
              insert: '<div class="icheck_line-icon"></div>' + label_text
            });
        });

        FX.Accordion.init();
    });

    return FX;
}(FX || {}, jQuery));
